import { render, staticRenderFns } from "./InformationBasicInfoPanel.vue?vue&type=template&id=9b2c26e8&"
import script from "./InformationBasicInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./InformationBasicInfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports